// extracted by mini-css-extract-plugin
module.exports = {"supportDeskBtn":"DefaultLayout_supportDeskBtn_26toL","icon":"DefaultLayout_icon_3jlQk","spinAround":"DefaultLayout_spinAround_n2Dht"};